import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import clsx from 'clsx';
import { RadioLinkItem } from './RadioLinkItem';
type FilterDropdownContentProps = {
  className?: string;
  label: string;
  variant: 'button-group' | 'radio-group';
  options: {
    label: ReactNode;
    value: string;
  }[];
  selected?: string;
  onChange: (selected: string | undefined) => void;
};
export const FilterDropdownContent = t0 => {
  const $ = _c(18);
  const {
    className,
    label,
    variant,
    options,
    selected,
    onChange
  } = t0;
  const t1 = variant === "button-group" ? "gap-2" : "gap-4";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = clsx("grid", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <legend className="sr-only">{label}</legend>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onChange || $[6] !== options || $[7] !== selected || $[8] !== variant) {
    let t5;
    if ($[10] !== onChange || $[11] !== selected || $[12] !== variant) {
      t5 = option => {
        const isSelected = selected === option.value;
        return <RadioLinkItem variant={variant} key={option.value} checked={isSelected} onChange={() => onChange(option.value)}>{option.label}</RadioLinkItem>;
      };
      $[10] = onChange;
      $[11] = selected;
      $[12] = variant;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = options.map(t5);
    $[5] = onChange;
    $[6] = options;
    $[7] = selected;
    $[8] = variant;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className="w-full"><fieldset className={t2}>{t3}{t4}</fieldset></div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};